import script from "./OptionForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OptionForm.vue?vue&type=script&lang=ts&setup=true"

import "./OptionForm.vue?vue&type=style&index=0&id=d69c7e7a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d69c7e7a"]])

export default __exports__